export default __webpack_public_path__ + "static/media/rETH.f60328b1.webp";